/**
 *  客户调研结果
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import {  Spin,Tabs,Tooltip} from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@/components/Lang/Lang";
import SurveyTaskFromShow from "@components/SurveyTaskFromDrawer/SurveyTaskFromShow";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import VipLvLevel from "@components/Icon/vip-badge/vipLvLevel";
import { Link } from "react-router-dom";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import { getIntlYYMMDD, sortBy } from '@utils/utils';
import dayjs from 'dayjs';
import "./List.less";

class CustomsResearchResults extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            tabKay: '10',
            tabOptions:[
                {
                    key:'10',
                    name:Lang({id:"XinKeHu2", default:"新客户"}),
                    // count:'allBuyerTotal',
                },
                {
                    key:'20',
                    name:Lang({id:"YuLiuShiKeHu", default:"预流失客户"}),
                },
            ],
            searchFormOptions:[//
                {
                    name:'buyerSurveyCode',
                    cnPlaceholder:'请选择问卷',
                    cnPlaceholderId:'QingXuanZeWenJuan',
                    type:'Enum',
                    // canSearch:true, // 选择搜索,
                    enumClass:'buyer_survey_code',
                    hiddenLabel:true,
                    enumCanAll:true,
                    enumSort:"DESC",
                    width:150,
                },
                {
                    name:'keyword',
                    cnPlaceholder:'搜索客户名称/编号/联系电话',
                    cnPlaceholderId:'SouSuoKeHuMingChengBianHa',
                    hiddenLabel:true,
                    width:216,
                },
            ],
            columns:[
                {
                    cnTitle: '调研活动',
                    cnTitleId: 'DiaoYanHuoDong',
                    dataIndex: 'activityName',
                    render: (activityName, record) => {
                        return(<>
                            <div className={"fw_500 black89"}>
                                {activityName}
                            </div>
                            <div>
                                {record.surveyName}
                            </div>
                            <div>
                                {record.activityStartTime?dayjs(record.activityStartTime).format('YYYY.MM.DD'):'-'}
                                <span className={"ml_2 mr_2"}>-</span>
                                {record.activityEndTime?dayjs(record.activityEndTime).format('YYYY.MM.DD'):'-'}
                            </div>
                        </>)}
                },
                {
                    cnTitle: '客户信息',
                    cnTitleId: 'KeHuXinXi',
                    width:200,
                    dataIndex: 'buyerCode',
                    render: (buyerCode, item) => {
                        return(<>
                            <div className={"flex-item-ver-center"}>
                                <Link target={"_blank"}
                                      className="color-blue3 fw_700 font-16"
                                      to={`/customer/detail?id=${item.buyerId}`} >
                                    {item.buyerCode||'-'}
                                </Link>
                                {(item.isTargetCustomer=="1"||item.pointLevel&&item.pointLevel>0)?<span className={"spanLevel ml_4"}>
                                    {item.isTargetCustomer=="1"?<i className={"ri-verified-badge-fill"} />:null}
                                    {item.pointLevel&&item.pointLevel>0?<VipLvLevel grade={item.pointLevel} width={24} />:null}
                                </span>:null}
                                {item.isKaBuyer=="1"?<span className={"ml_4 kaLabel"}>KA</span>:null}
                            </div>
                            {item.buyerName?<div className="fw_500 mt_4">{item.buyerName}</div>:null}
                            {item.cityName?<div className="black45 mt_4">{item.cityName}</div>:null}
                        </>)}
                },
                {
                    cnTitle: '第一个订单',
                    cnTitleId: 'DiYiGeDingDan',
                    dataIndex: 'createTime',
                    width:300,
                    render: (item = {}, record) => (<>
                        <Tooltip title={<div dangerouslySetInnerHTML={{__html:Lang({id:"WenJuanDiaoChaJieGuoXiang",default:`<div><i class="popRoundNum">1</i>首单确认时间</div> <div><i class="popRoundNum">2</i>首单入库时间</div> <div><i class="popRoundNum">3</i>首单出库时间</div>`})}}></div>}>
                            {/*{Lang({id:"ShouDanQueRenShiJian",default:"首单确认PO时间"})}*/}
                            <div><span className={"roundBgNum mr_4"}>1</span>
                                {record.firstOrderTime?getIntlYYMMDD(record.firstOrderTime):'-'}
                            </div>
                            {/*{Lang({id:"ShouDanRuKuShiJian",default:"首单入库时间"})}*/}
                            <div><span className="roundBgNum mr_4">2</span>
                            {record.firstInStorageTime?getIntlYYMMDD(record.firstInStorageTime):'-'}</div>
                            {/*{Lang({id:"ShouDanChuKuShiJian",default:"首单出库时间"})}*/}
                            <div><span className="roundBgNum mr_4">3</span>
                            {record.firstOutStorageTime?getIntlYYMMDD(record.firstOutStorageTime):'-'}</div>
                        </Tooltip>
                    </>)},

                {
                    cnTitle: '问卷填写时间',
                    cnTitleId: 'WenJuanTianXieShiJian',
                    dataIndex: 'handleTime',
                    render: (handleTime, record) => handleTime?getIntlYYMMDD(handleTime,"HH:mm"):'-'
                },
                {
                    cnTitle: '填写人',
                    cnTitleId: 'TianXieRen',
                    dataIndex: 'handlerUser',
                    render: (handlerUser, record) => {
                        return(<div className={"fw_500 black45"}>
                            <i className="ri-user-line mr_6" />
                            {handlerUser||"-"}
                            {record.handlePlatform!=="mg"?<span className={"ml_4"}>{Lang({id:"KeHu",default:"客户"})}</span>:null}
                        </div>)}
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<>
                        {/* 满意度调查*/}
                        <SurveyTaskFromShow buyerId={record.buyerId} item={{
                            name:record.buyerName,
                            buyerCode:record.buyerCode,
                            telCode:record.telCode,
                            mobile:record.mobile,
                            abbreviate:record.abbreviate,
                        }} >
                            <AuthBtn icon={"ri-draft-line"} tips = {Lang({id:"ManYiDuDiaoCha",default:"满意度调查"})}
                                     className={"blueIconTips"}
                            />
                        </SurveyTaskFromShow>
                    </>)},
            ],
            columnsByLoss:[
                {
                    cnTitle: '调研活动',
                    cnTitleId: 'DiaoYanHuoDong',
                    dataIndex: 'activityName',
                    render: (activityName, record) => {
                        return(<>
                            <div className={"fw_500 black89"}>
                                {activityName}
                            </div>
                            <div>
                                {record.surveyName}
                            </div>
                            <div>
                                {record.activityStartTime?dayjs(record.activityStartTime).format('YYYY.MM.DD'):'-'}
                                <span className={"ml_2 mr_2"}>-</span>
                                {record.activityEndTime?dayjs(record.activityEndTime).format('YYYY.MM.DD'):'-'}
                            </div>
                        </>)}
                },
                {
                    cnTitle: '客户信息',
                    cnTitleId: 'KeHuXinXi',
                    width:200,
                    dataIndex: 'buyerCode',
                    render: (buyerCode, item) => {
                        return(<>
                            <div className={"flex-item-ver-center"}>
                                <Link target={"_blank"}
                                      className="color-blue3 fw_700 font-16"
                                      to={`/customer/detail?id=${item.buyerId}`} >
                                    {item.buyerCode||'-'}
                                </Link>
                                {(item.isTargetCustomer=="1"||item.pointLevel&&item.pointLevel>0)?<span className={"spanLevel ml_4"}>
                                    {item.isTargetCustomer=="1"?<i className={"ri-verified-badge-fill"} />:null}
                                    {item.pointLevel&&item.pointLevel>0?<VipLvLevel grade={item.pointLevel} width={24} />:null}
                                </span>:null}
                                {item.isKaBuyer=="1"?<span className={"ml_4 kaLabel"}>KA</span>:null}
                            </div>
                            {item.buyerName?<div className="fw_500 mt_4">{item.buyerName}</div>:null}
                            {item.cityName?<div className="black45 mt_4">{item.cityName}</div>:null}
                        </>)}
                },
                {
                    cnTitle: '最近一个订单',
                    cnTitleId: 'ZuiJinYiGeDingDan',
                    dataIndex: 'createTime',
                    width:300,
                    render: (item = {}, record) => (<>
                        <Tooltip title={<div dangerouslySetInnerHTML={{__html:Lang({id:"WenJuanDiaoChaJieGuoXiang2",default:`<div><i class="popRoundNum">1</i>最近确认PO时间</div> <div><i class="popRoundNum">2</i>最近入库时间</div> <div><i class="popRoundNum">3</i>最近出库时间</div>`})}}></div>}>
                            <div>
                                {/*{Lang({id:"ZuiJinQueRenShiJian",default:"最近确认PO时间"})}*/}
                                <span className={"roundBgNum mr_4"}>1</span>
                                {record.lastOrderTime?getIntlYYMMDD(record.lastOrderTime):'-'}
                            </div>
                            <div>
                                {/*{Lang({id:"ZuiJinRuKuShiJian",default:"最近入库时间"})}*/}
                                <span className={"roundBgNum mr_4"}>2</span>
                                {record.lastInStorageTime?getIntlYYMMDD(record.lastInStorageTime):'-'}</div>
                            <div>
                                {/*{Lang({id:"ZuiJinChuKuShiJian",default:"最近出库时间"})}*/}
                                <span className={"roundBgNum mr_4"}>3</span>
                                {record.lastOutStorageTime?getIntlYYMMDD(record.lastOutStorageTime):'-'}</div>
                        </Tooltip>
                    </>)},

                {
                    cnTitle: '问卷填写时间',
                    cnTitleId: 'WenJuanTianXieShiJian',
                    dataIndex: 'handleTime',
                    render: (handleTime, record) => handleTime?getIntlYYMMDD(handleTime,"HH:mm"):'-'
                },
                {
                    cnTitle: '填写人',
                    cnTitleId: 'TianXieRen',
                    dataIndex: 'handlerUser',
                    render: (handlerUser, record) => {
                        return(<div className={"fw_500 black45"}>
                            <i className="ri-user-line mr_6" />
                            {handlerUser||"-"}
                            {record.handlePlatform!=="mg"?<span className={"ml_4"}>{Lang({id:"KeHu",default:"客户"})}</span>:null}
                        </div>)}
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<>
                        {/* 满意度调查*/}
                        <SurveyTaskFromShow buyerId={record.buyerId} item={{
                            name:record.buyerName,
                            buyerCode:record.buyerCode,
                            telCode:record.telCode,
                            mobile:record.mobile,
                            abbreviate:record.abbreviate,
                        }} >
                            <AuthBtn icon={"ri-draft-line"} tips = {Lang({id:"ManYiDuDiaoCha",default:"满意度调查"})}
                                     className={"blueIconTips"}
                            />
                        </SurveyTaskFromShow>
                    </>)},
            ],
        }
    }
    tabsOnChange(key) {
        this.setState({
            tabKay: key,
        },() => {
            // this.onRefTabChildOne.handleFetch(1)
        })
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    componentWillMount() {
    }
    render(){
        const { loading,searchFormOptions,columns,tabKay,tabOptions=[],columnsByLoss } = this.state;

        const currPageName = Lang({id: "WenJuanDiaoChaJieGuo",default: "问卷调查结果"});
        return (<Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className={'listCustomsResearchResults'}>
                    <Tabs activeKey={tabKay}onChange={this.tabsOnChange.bind(this)}
                          destroyInactiveTabPane={true}
                          items={
                              tabOptions.map(opt=>{return {
                                  key: opt.key,
                                  label:opt.name,
                                  children:<AutoFetchTable columns={tabKay==10?columns:columnsByLoss}
                                                           onRef={this.onRefTabOne}
                                      // flagShowReset={false}
                                                           rowKey={"createTime"}
                                                           precondition={{type:tabKay}} // 10:新客调研 20:预流失客户调研
                                                           searchFormOptions={searchFormOptions}
                                                           fetchApi={'/service/mg/buyer/survey/task-done-list'} />
                              }} ) }
                    >
                    </Tabs>

                </div>
            </Spin>

        )
    }
}

export default CustomsResearchResults;
